<template>
  <div>
    <div class="contents">
      <table class="table board toggle-xl">
        <thead>
          <tr>
            <!-- <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th> -->
            <th class="d-none d-xl-table-cell">
              {{ $t("title.common.name") }}
            </th>
            <th class="col-auto">{{ $t("title.common.id") }}</th>
            <th class="d-none d-xl-table-cell">
              {{ $t("title.admin.part") }}
            </th>
            <th class="d-none d-xl-table-cell">
              {{ $t("title.admin.position") }}
            </th>
            <th class="d-none d-md-table-cell">
              {{ $t("title.admin.phone") }}
            </th>
            <th class="col-auto">{{ $t("title.common.email") }}</th>
            <th class="d-none d-xl-table-cell">
              {{ $t("title.common.registration") }}
            </th>
            <th class="d-none d-xl-table-cell">
              {{ $t("title.common.status") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="dataYn">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <!-- <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td> -->
              <td class="d-none d-xl-table-cell">{{ item.name }}</td>
              <td class="col-auto text-start">
                <a class="more" @click="goView(index)">{{ item.id }}</a>
              </td>
              <td class="d-none d-xl-table-cell">
                {{ item.part | partType }}
              </td>
              <td class="d-none d-xl-table-cell">
                {{ item.position | positionType }}
              </td>
              <td class="d-none d-md-table-cell">{{ item.phone }}</td>
              <td class="col-auto">{{ item.email }}</td>
              <td class="d-none d-xl-table-cell text-date">
                {{ item.timezone_regdate | dateformat }}
              </td>
              <td class="d-none d-xl-table-cell">
                <label
                  :class="{
                    'status-pend px-2': item.status === '0',
                    'status-done px-2': item.status === '1',
                  }"
                >
                  {{ item.status | status4 }}
                </label>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="8">
                <!-- <a class="btn_view" @click="goView(index)">
                  <img src="/img/ico_edit.png" />
                </a> -->
                <div class="toggle-content">
                  <!-- <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">{{ item.no }}</div>
                  </div> -->
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.name") }}</div>
                    <div class="col-8">{{ item.name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.admin.part") }}</div>
                    <div class="col-8">{{ item.part | partType }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.admin.position") }}</div>
                    <div class="col-8">{{ item.position | positionType }}</div>
                  </div>
                  <div class="row d-md-none">
                    <div class="col-4">{{ $t("title.admin.phone") }}</div>
                    <div class="col-8">{{ item.phone }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.registration") }}
                    </div>
                    <div class="col-8 text-date">
                      {{ item.timezone_regdate | dateformat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.status") }}</div>
                    <div class="col-8">
                      <label
                        :class="{
                          'status-pend px-2': item.status === '0',
                          'status-done px-2': item.status === '1',
                        }"
                      >
                        {{ item.status | status4 }}
                      </label>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="pageTotal"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="pageTotal > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.write')"
          @click="$router.push({ path: 'write' })"
          >{{ $t("button.common.write") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/manager";

export default {
  name: "ManagerList",
  data() {
    return {
      searchData: {
        startdate:
          this.$route.query.startdate ||
          this.$store.state.searchData.startdate ||
          1,
        enddate:
          this.$route.query.enddate ||
          this.$store.state.searchData.enddate ||
          1,
        pageno:
          this.$route.query.pageno || this.$store.state.searchData.pageno || 1,
      },
      pageTotal: 1,
      totalCnt: 0,
      dataYn: true,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.startdate": function () {
      this.searchData.pageno = 1;
      this.getList();
    },
    "searchData.enddate": function () {
      this.searchData.pageno = 1;
      this.getList();
    },

    "searchData.pageno": function () {
      this.getList();
    },
  },

  created() {
    this.getList();
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$router
        .push({
          name: "ManagerList",
          query: {
            startdate: this.searchData.startdate,
            enddate: this.searchData.enddate,
          },
        })
        .catch(() => {});
    },
    getList() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.getList(this.searchData, (flag, data) => {
        if (flag) {
          if (data.managerlistcnt <= 0) {
            this.dataYn = false;
            return false;
          } else {
            this.dataYn = true;
          }
          this.totalCnt = data.managerlistcnt;
          this.pageTotal = Math.ceil(data.managerlistcnt / this.rows);
          this.items = data.managerlist;
        } else {
          this.dataYn = false;
          this.pageTotal = 0;
          alert(data);
        }
      });
    },
    goView(idx) {
      let no = this.items[idx].no;
      this.$router.push({
        name: "Adminedit",
        params: { adminno: no },
      });
    },
    linkGen(pageNum) {
      // return pageNum === 1
      //   ? `?searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`
      //   : `?page=${pageNum}&searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
};
</script>
